import DefaultManager from "./Default.manager";

class DMOManager extends DefaultManager {
  signboardId;

  constructor(signboardId) {
    super(signboardId);
    this.signboardId = signboardId;
  }

  showCategoryIndex() {
    return true;
  }
}

export default DMOManager;
